import React from 'react'
import PosDataComp from 'src/Components/PosData/PosDataComp'

const PosData = () => {
  return (
    <div><PosDataComp/></div>
  )
}

export default PosData